/**
 * RequireAccess — page-level guard for routes a role cannot use.
 *
 * The API already refuses these requests with 403; this keeps the page from
 * rendering a form (or "create your first ...") the user can never submit.
 *
 *   <RequireAccess allowed={canCreateCompetition(user)} what="create tournaments">
 *     <TournamentCreation ... />
 *   </RequireAccess>
 */
import React from "react";
import { Link } from "react-router-dom";

const RequireAccess = ({ allowed, what = "open this page", backTo = "/dashboard", children }) => {
  if (allowed) return children;

  return (
    <div
      role="alert"
      data-testid="access-denied"
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "2rem",
        color: "#fff",
      }}
    >
      <h2 style={{ marginBottom: "0.75rem" }}>Not allowed</h2>
      <p style={{ color: "#aaa", marginBottom: "1.5rem", maxWidth: 480 }}>
        Your role does not allow you to {what}. Ask your organization admin for access or
        request a role upgrade from your profile.
      </p>
      <Link to={backTo} style={{ color: "#4dabf7" }}>
        Go back
      </Link>
    </div>
  );
};

export default RequireAccess;
